import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  TextField,
  //IconButton,
  InputAdornment,
  TableSortLabel,
} from "@mui/material";
import { Search } from "@mui/icons-material";
//import { Search, FilterList } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { Selector } from "./selector";
import styled from "styled-components";
import { format } from "date-fns";
import { convertToLocalCurrency } from "../../utils/currency";
import DateRangePickerComponent from "../../components/common/DateRangePickerComponent";

const SelectorWrap = styled.div`
  position: relative;
  .dropdown-content {
    visibility: hidden;
    position: absolute;
    top: 0;
    right: 0;
    background-color: #fff;
    width: 150px;
    font-size: 12px;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
    z-index: 1000000000;
    overflow-x: hidden;
    opacity: 0;
    max-height: 0;
    transition: max-height 0.6s ease, opacity 0.2s ease, visibility 0.2s ease;

    a {
      color: #000;
      padding: 10px 20px;
      text-decoration: none;
      display: block;
      text-align: left;

      &:hover {
        background-color: #f1f1f1;
      }
    }
  }

  &.active .dropdown-content {
    visibility: visible;
    opacity: 1;
    max-height: 500px;
    border-bottom: none !important;
    transition: max-height 0.6s ease, opacity 0.2s ease, visibility 0.2s ease;
  }

  /* For rows near the bottom: flip dropdown upwards so it doesn't go behind pagination */
  &.open-up .dropdown-content {
    top: auto;
    bottom: 200px;
    right: 50px;
    position: fixed;
  }
`;
const StatusLabel = styled.span`
  display: inline-block;
  font-size: 12px;
  padding: 10px 20px;
  border-radius: 16px;
  font-weight: bold;
  text-align: center;

  color: ${({ isActive }) => (isActive ? "#03a9f4" : "#B42318")};

  background-color: ${({ isActive }) => (isActive ? "#e8f8ff" : "#FEF3F2")};
`;
// const DeletedLabel = styled.span`
//   display: inline-block;
//   font-size: 12px;
//   padding: 10px 20px;
//   border-radius: 16px;
//   font-weight: bold;

//   color: ${({ deletedAt }) => (deletedAt == null ? "#027A48" : "#B42318")};

//   background-color: ${({ deletedAt }) =>
//     deletedAt == null ? "#ECFDF3" : "#FEF3F2"};
// `;
const ApprovalLabel = styled.span`
  display: inline-block;
  font-size: 12px;
  font-weight: bolder;
  text-align: center;
  span {
    font-size: 15px;
  }
  color: ${({ isApproved, status }) =>
    isApproved === "APPROVED" || status === "APPROVED" || status === "PAID"
      ? "#03a9f4"
      : isApproved === "REJECTED" || status === "REJECTED"
      ? "#FF2D55"
      : "#AF52DE"};
`;

const Container = styled.div`
  display: flex;
  gap: 10px;
  .link-buttons {
    display: flex;
    gap: 10px;
    .see-more2 {
      padding: 10px 5px 10px 10px;
      height: 45px;
      border: 1px solid #989fad;
      border-radius: 12px;
      font-size: 14px;
      background-color: transparent;
      text-decoration: none;
      cursor: pointer;
      color: #344054;
    }
  }
  .export-button {
    padding: 8px 16px;
    background-color: #03a9f4;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    margin-left: 10px;

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
`;

const GenericTableComponent = ({
  columns,
  data,
  filterSearch,
  hideSearch,
  hideActiveSearch,
  hideDateSearch,
  hideApprove,
  hideReject,
  paginate,
  viewLink,
  detailLink,
  detailLinkText,
  viewLinkText,
  editLink,
  publisherLink,
  campaignLink,
  updateCpa,
  hideView,
  hideEdit,
  user,
  publisher,
  campaignPostback,
  postbackView,
  page,
  rowsPerPage,
  handlePageChange,
  handleRowsPerPageChange,
  totalItems,
  handleSearchChange,
  triggerSearch,
  search,
  reportView,
  billingView,
  showModal,
  handleApproveClick,
  handleRejectClick,
  handlePause,
  setDateRange,
  dateRange,
  onFilterChange,
  handleActiveState,
  index,
  showExport,
  onExport,
  exportLoading,
  onRowClick,
}) => {
  //const [search, setSearch] = useState("");

  // const handleSearchChange = (event) => {
  //   setSearch(event.target.value);
  // };

  // const data = data.filter((row) => {
  //   return columns.some((column) =>
  //     row[column.id]?.toString().toLowerCase().includes(search.toLowerCase())
  //   );
  // });
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (orderBy) {
      if (order === "asc") {
        return a[orderBy] < b[orderBy] ? -1 : 1;
      } else {
        return a[orderBy] > b[orderBy] ? -1 : 1;
      }
    }
    return 0;
  });

  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleDropdown = (currentIndex) => {
    setActiveDropdown((prev) => (prev === currentIndex ? null : currentIndex));
  };

  const closeDropdown = () => setActiveDropdown(null);

  useEffect(() => {
    // Close dropdown when clicking outside
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".selector-wrap")) {
        closeDropdown();
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  // const formatMonthYear = (monthYear) => {
  //   const [month, year] = monthYear.trim().split(/\s+/);
  //   const monthMap = {
  //     January: "01",
  //     February: "02",
  //     March: "03",
  //     April: "04",
  //     May: "05",
  //     June: "06",
  //     July: "07",
  //     August: "08",
  //     September: "09",
  //     October: "10",
  //     November: "11",
  //     December: "12",
  //   };

  //   return `${monthMap[month]}-${year.slice(-2)}`;
  // };

  return (
    <>
      {filterSearch && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "16px",
            marginBottom: "-20px",
            // overflow: "visible",
            // overflowX: "auto",
          }}
        >
          {hideSearch ? <div></div> : ""}
          {hideSearch ? (
            ""
          ) : (
            <TextField
              label="Search by name"
              variant="outlined"
              size="small"
              value={search}
              onChange={handleSearchChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Search
                      onClick={triggerSearch}
                      style={{ cursor: "pointer" }}
                    />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#03a9f4",
                  },
                },
                "& .MuiInputLabel-root": {
                  "&.Mui-focused": {
                    color: "#03a9f4",
                  },
                },
              }}
            />
          )}
          <Container>
            {hideActiveSearch ? (
              ""
            ) : (
              <div className="link-buttons">
                <select
                  className="see-more2"
                  onChange={(e) => onFilterChange(e.target.value)}
                >
                  <option value="" readonly>
                    Filter by status
                  </option>
                  <option value="ACTIVATED">Active</option>
                  <option value="DEACTIVATED">Inactive</option>
                </select>
              </div>
            )}

            {hideDateSearch ? (
              ""
            ) : (
              <DateRangePickerComponent
                dateRange={dateRange}
                onDateChange={setDateRange}
              />
            )}

            {showExport ? (
              <button
                className="export-button"
                onClick={onExport}
                disabled={exportLoading}
              >
                {exportLoading ? "Exporting..." : "Export CSV"}
              </button>
            ) : null}
          </Container>
        </div>
      )}
      <Paper
        sx={{
          width: "100%",
          overflowX: "auto",
          overflowY: "visible",
          paddingTop: "20px",
          boxShadow: "none",
        }}
      >
        <div style={{ overflow: "visible" }}>
          <TableContainer
            sx={{
              overflowX: "auto",
              overflowY: "visible",
            }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      sx={{
                        border: "none",
                        backgroundColor: "#03a9f4",
                        fontWeight: "600",
                        letterSpacing: "0.5px",
                        fontSize: "13px",
                        color: "#ffffff",
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={() => handleRequestSort(column.id)}
                        hideSortIcon={false}
                        sx={{
                          "& .MuiTableSortLabel-icon": {
                            color: "#ffffff !important",
                            opacity: "1 !important",
                            height: "13px",
                          },
                          "&.Mui-active": {
                            color: "#ffffff !important",
                          },
                          "&:hover": {
                            color: "#e3f2fd !important",
                          },
                        }}
                      >
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                  <TableCell
                    sx={{
                      border: "none",
                      backgroundColor: "#03a9f4",
                      fontWeight: "600",
                      fontSize: "13px",
                      color: "#ffffff",
                    }}
                  ></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedData.map((row, index) => (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    {columns.map((column) => (
                      <TableCell
                        sx={{
                          backgroundColor: "#ffff",
                          border: "none",
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "#667085",
                        }}
                        key={column.id}
                      >
                        {column.id === "campaignName" && row.photoUrl ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              textTransform: "capitalize",
                            }}
                          >
                            <img
                              src={row.photoUrl[0].url}
                              alt={row.name}
                              style={{ width: 40, height: 40, marginRight: 10 }}
                            />
                            {row[column.id]}
                          </div>
                        ) : column.id === "campaign_campaignName" &&
                          row.campaign ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.campaign.campaignName}
                          </div>
                        ) : column.id === "advertiser" ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.firstName + " " + row.lastName}
                          </div>
                        ) : column.id === "user" && row.user ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.user.firstName + " " + row.user.lastName}
                          </div>
                        ) : column.id === "postbackCampaign" &&
                          row.campaignPublisher?.campaign ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.campaignPublisher?.campaign?.campaignName}
                          </div>
                        ) : column.id === "postbackUser" &&
                          row.campaignPublisher?.publisher ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.campaignPublisher?.publisher?.name}
                          </div>
                        ) : column.id === "postbackCostPerUser" &&
                          row.campaignPublisher ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.campaignPublisher?.costPerUser}
                          </div>
                        ) : column.id === "createdAt" ||
                          column.id === "date" ||
                          column.id === "paidAt" ||
                          column.id === "createdat" ? (
                          format(new Date(row[column.id]), "dd-MM-yyyy")
                        ) : column.id === "usercreatedAt" && row.user ? (
                          format(new Date(row.user?.createdAt), "dd-MM-yyyy")
                        ) : column.id === "isActive" ||
                          column.id === "publisher_isActive" ? (
                          <StatusLabel isActive={row[column.id]}>
                            {row[column.id] ? "Active" : "Inactive"}
                          </StatusLabel>
                        ) : column.id === "isLocked" ? (
                        <StatusLabel isActive={row[column.id]}>
                          {row[column.id] ? "True" : "False"}
                        </StatusLabel>
                        ) : column.id === "status" ? (
                          <ApprovalLabel status={row[column.id]}>
                            <span>●</span> {row[column.id]}
                          </ApprovalLabel>
                        ) : column.id === "userActive" && row.user ? (
                          <StatusLabel isActive={row.user.isActive}>
                            {row.user.isActive ? "Active" : "Inactive"}
                          </StatusLabel>
                        ) : column.id === "isApproved" &&
                          row?.isActive === false ? (
                          <ApprovalLabel isApproved={row.isApproved}>
                            <span>●</span> {row.isApproved} - PAUSED
                          </ApprovalLabel>
                        ) : column.id === "isApproved" ? (
                          <ApprovalLabel isApproved={row[column.id]}>
                            <span>●</span> {row[column.id]}
                          </ApprovalLabel>
                        ) : column.id === "userApproved" && row.user ? (
                          <ApprovalLabel isApproved={row.user.isApproved}>
                            <span>●</span> {row.user.isApproved}
                          </ApprovalLabel>
                        ) : column.id === "conversion_rate" ||
                          column.id === "conversionRate" ||
                          column.id === "totalconversionrate" ||
                          column.id === "conversionrate" ? (
                          row[column.id] + "%"
                        ) : column.id === "amountSpent" ? (
                          convertToLocalCurrency(row[column.id])
                        ) : column.id === "amountDue" ? (
                          convertToLocalCurrency(row[column.id])
                        ) : column.id === "campaignBudget" ||
                          column.id === "totalamountspent" ||
                          column.id === "amountspent" ||
                          column.id === "campaignbudget" ||
                          column.id === "totalhoardedconversionamount" ||
                          column.id === "totalHoardedConversionAmount" ||
                          column.id === "totalAmount" ||
                          column.id === "amountPaid" ||
                          column.id === "totalhoardedamount" ? (
                          convertToLocalCurrency(row[column.id])
                        ) : column.id === "publisherName" && row.publisher ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.publisher?.name}
                          </div>
                        ) : column.id === "publisherReference" &&
                          row.publisher ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.publisher?.publisherReference}
                          </div>
                        ) : column.id === "campaign_campaignName" &&
                          row.campaign ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.campaign?.campaignName}
                          </div>
                        ) : column.id === "campaign_reach" &&
                          (row.campaign || row.user.campaigns) ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.campaign?.reach || row.user?.campaigns?.reach}
                          </div>
                        ) : column.id === "campaign_acquistion" &&
                          row.campaign ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.campaign?.acquistion}
                          </div>
                        ) : column.id === "campaign_campaignReference" &&
                          row.campaign ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.campaign?.campaignReference}
                          </div>
                        ) : column.id === "campaign_conversionRate" &&
                          row.campaign ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.campaign?.conversionRate}%
                          </div>
                        ) : column.id === "campaign_ecpm" && row.campaign ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.campaign?.eCPM}
                          </div>
                        ) : column.id === "campaign_hoardedConversion" &&
                          row.campaign ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.campaign?.hoardedConversion}
                          </div>
                        ) : column.id === "campaign_totalConversion" &&
                          row.campaign ? (
                          <div style={{ textTransform: "capitalize" }}>
                            {row.campaign?.totalConversion}
                          </div>
                        ) : column.id === "campaign_isActive" &&
                          row.campaign ? (
                          <StatusLabel isActive={row.campaign?.isActive}>
                            {row.campaign?.isActive ? "Active" : "Inactive"}
                          </StatusLabel>
                        ) : (
                          row[column.id]
                        )}
                      </TableCell>
                    ))}
                    <TableCell
                      sx={{ border: "none", backgroundColor: "#ffff" }}
                    >
                      {billingView ? (
                        <SelectorWrap
                          className={`selector-wrap ${
                            activeDropdown === index ? "active" : ""
                          } ${index >= sortedData.length - 3 ? "open-up" : ""}`}
                        >
                          <div onClick={() => toggleDropdown(index)}>
                            <Selector />
                          </div>
                          <div className="dropdown-content">
                            <Link onClick={() => showModal(row.id)}>View</Link>
                          </div>
                        </SelectorWrap>
                      ) : reportView ? (
                        <SelectorWrap
                          className={`selector-wrap ${
                            activeDropdown === index ? "active" : ""
                          }`}
                        >
                          <div onClick={() => toggleDropdown(index)}>
                            <Selector />
                          </div>
                          <div className="dropdown-content">
                            <Link
                              to={`${detailLink}/${
                                row.campaignReference || row.publisherreference
                              }?name=${encodeURIComponent(row.campaignName || row.publishername)}`}
                              onClick={(e) => {
                                if (onRowClick) {
                                  e.preventDefault();
                                  onRowClick(row);
                                }
                              }}
                            >
                              {detailLinkText}
                            </Link>

                            <Link
                              to={`${viewLink}/${
                                row.campaignReference || row.publisherreference
                              }?name=${encodeURIComponent(row.campaignName || row.publishername)}`}
                            >
                              {viewLinkText}
                            </Link>
                          </div>
                        </SelectorWrap>
                      ) : postbackView ? (
                        ""
                      ) : (
                        <SelectorWrap
                          className={`selector-wrap ${
                            activeDropdown === index ? "active" : ""
                          } ${index >= sortedData.length - 3 ? "open-up" : ""}`}
                        >
                          <div onClick={() => toggleDropdown(index)}>
                            <Selector />
                          </div>
                          <div className="dropdown-content">
                            {hideView ? (
                              ""
                            ) : (
                              <Link
                                to={`${viewLink}/${
                                  user
                                    ? row.user.id
                                    : publisher
                                    ? row.publisher_id
                                    : row.id
                                }`}
                              >
                                View
                              </Link>
                            )}
                            {hideEdit ? (
                              ""
                            ) : (
                              <Link
                                to={`${editLink}/${
                                  user
                                    ? row.user.id
                                    : publisher
                                    ? row.publisher_id
                                    : row.id
                                }`}
                              >
                                Edit
                              </Link>
                            )}
                            {campaignLink ? (
                              <Link
                                to={`${campaignLink}/${row.publisher_publisherReference}?name=${encodeURIComponent(row.publisher_name)}`}
                              >
                                Campaign links
                              </Link>
                            ) : (
                              ""
                            )}
                            {/* {publisher ? (
                              <Link onClick={() => showModal(row.publisher_id)}>
                                Set postback
                              </Link>
                            ) : (
                              // campaignPostback ? (
                              //   <Link onClick={() => showModal(row.id)}>
                              //     Set postback
                              //   </Link>
                              // ) :
                              ""
                            )} */}
                            {publisherLink && row?.isApproved === "APPROVED" ? (
                              <Link
                                to={`${publisherLink}/${row.campaignReference}?name=${encodeURIComponent(row.campaignName)}`}
                              >
                                Publisher links
                              </Link>
                            ) : (
                              ""
                            )}
                            {updateCpa && row?.isApproved === "APPROVED" ? (
                              <Link
                                onClick={() => updateCpa(row.campaignReference)}
                              >
                                Update cpa
                              </Link>
                            ) : (
                              ""
                            )}
                            {row?.isApproved === "APPROVED" &&
                            row?.isActive === true ? (
                              <Link onClick={() => handlePause(row.id)}>
                                Pause
                              </Link>
                            ) : (
                              ""
                            )}
                            {row?.isApproved === "APPROVED" &&
                            row?.isActive === false ? (
                              <Link onClick={() => handlePause(row.id)}>
                                Resume
                              </Link>
                            ) : (
                              ""
                            )}
                            {row?.isApproved === "PENDING" ||
                            row?.isApproved === "REJECTED" ? (
                              <>
                                {hideApprove ? (
                                  ""
                                ) : (
                                  <Link
                                    onClick={() => handleApproveClick(row.id)}
                                  >
                                    Approve
                                  </Link>
                                )}
                                {hideReject ||
                                row?.isApproved === "REJECTED" ? (
                                  ""
                                ) : (
                                  <Link
                                    onClick={() => handleRejectClick(row.id)}
                                  >
                                    Reject
                                  </Link>
                                )}
                              </>
                            ) : row?.user?.isApproved === "PENDING" ||
                              row?.user?.isApproved === "REJECTED" ||
                              row?.user?.isApproved === "APPROVED" ? (
                              <>
                                {hideApprove ||
                                row?.user?.isApproved === "APPROVED" ? (
                                  ""
                                ) : (
                                  <Link
                                    onClick={() =>
                                      handleApproveClick(row.user.id)
                                    }
                                  >
                                    Approve
                                  </Link>
                                )}
                                {hideReject ||
                                row?.user?.isApproved === "REJECTED" ? (
                                  ""
                                ) : (
                                  <Link
                                    onClick={() =>
                                      handleRejectClick(row.user.id)
                                    }
                                  >
                                    Reject
                                  </Link>
                                )}
                              </>
                            ) : (
                              ""
                            )}
                            {/* {(row.user.isApproved && row.user.isApproved === "PENDING") ? (
                          <>
                            {hideApprove ? (
                              ""
                            ) : (
                              <Link onClick={() => handleApproveClick(row.user.id)}>
                                Approve
                              </Link>
                            )}
                            {hideReject ? (
                              ""
                            ) : (
                              <Link onClick={() => handleRejectClick(row.user.id)}>
                                Reject
                              </Link>
                            )}
                          </>
                        ) : (
                          ""
                        )} */}
                            {row.user && row.user.isActive === false ? (
                              <Link
                                onClick={() => handleActiveState(row.user.id)}
                              >
                                Activate
                              </Link>
                            ) : row.user && row.user.isActive === true ? (
                              <Link
                                onClick={() => handleActiveState(row.user.id)}
                              >
                                Deactivate
                              </Link>
                            ) : (
                              ""
                            )}
                          </div>
                        </SelectorWrap>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {paginate && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 50, 100]}
            component="div"
            count={totalItems}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        )}
      </Paper>
    </>
  );
};

export default GenericTableComponent;
